import { IBaseResponseModel } from "@/app/models/types/base-response-model";
import { API_ENDPOINTS } from "../endpoints/api-endpoints";
import { apiService } from "../axios/axios-instance";
import { IBlogs, IBlog } from "@/app/models/types/blog-model";
import { IBlogCategory } from "@/app/models/types/blog-category-model";

export type IBlogResponse = IBaseResponseModel<IBlogs>;
export type IBlogCategoryResponse = IBaseResponseModel<IBlogCategory[]>;
export type IBlogDetailResponse = IBaseResponseModel<IBlog>;

interface IBlogPrams {
  skip: number;
  limit: number;
  category?: string;
  search?: string;
}

export class BlogApi {
  static async getBlogList(params: IBlogPrams): Promise<IBlogResponse> {
    return apiService.get<IBlogs>(API_ENDPOINTS.BLOGS.GET_BLOGS, params);
  }

  static async getBlogCategoryList(): Promise<IBlogCategoryResponse> {
    return apiService.get<IBlogCategory[]>(
      API_ENDPOINTS.BLOGS.GET_BLOGS_CATEGORIES,
      { is_all: "0" }
    );
  }

  static async getBlogBySlug(slug: string): Promise<IBlogDetailResponse> {
    return apiService.get<IBlog>(API_ENDPOINTS.BLOGS.GET_BLOG_BY_SLUG, {
      slug,
    });
  }
}
